<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication">
<p><span>• • •This book is dedicated to everyone working to make their corner of the world just a little bit better.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?298289cc